import { createRootRoute, Outlet, useRouterState } from "@tanstack/react-router";
import { useEffect, useCallback, useRef } from "react";
import { useAuthService } from "@/services/authService";
import { useAuthStore } from "@/store/authStore";
import EventUserDialog from "@/components/protected/event-user/EventUserDialog";
import { Toaster } from 'sonner';

export const Route = createRootRoute({
	component: () => {
		const { handleCheckIfLoggedIn } = useAuthService();
		const { isTokenChecked, isLoggedIn, hasEvents } = useAuthStore();
		const isCheckingAuth = useRef(false);

		// Memoize the auth check to prevent infinite re-renders
		const checkAuth = useCallback(async () => {
			if (isCheckingAuth.current) return;

			isCheckingAuth.current = true;

			try {
				await handleCheckIfLoggedIn();
			} finally {
				isCheckingAuth.current = false;
			}
		}, [handleCheckIfLoggedIn]);

		useEffect(() => {
			// Only check auth if token hasn't been checked yet
			if (!isTokenChecked) {
				checkAuth();
			}
		}, [isTokenChecked, checkAuth]);

		const ScrollToTop = () => {
			const location = useRouterState();
			useEffect(() => {
				window.scrollTo({
					top: 0,
					behavior: "smooth"
				});
			}, [location.location.pathname]);
			return null;
		};

		return (
			<>
				<ScrollToTop />
				<Outlet />
				{isTokenChecked && isLoggedIn && !hasEvents && <EventUserDialog />}
				<Toaster />
			</>
		);
	},
});
